var exports = {
  "I2": "xcc377c0b--bf9c09--escrow",
  "Qs": "xcc377c0b--bf9c09--content",
  "DD": "xcc377c0b--bf9c09--title",
  "ne": "xcc377c0b--bf9c09--controls",
  "A4": "xcc377c0b--bf9c09--control",
};

module.exports = exports;
